module.exports = __webpack_public_path__ + "img/xem.6992cf33.svg";